export default "__VITE_ASSET__MZSB3WfF__"